
import { Component } from 'vue-property-decorator';

import RemoteDataTable, {
  RemoteDataField
} from '@/components/RemoteDataTable.vue';

import MenuGroupScheduleAddEdit from './MenuGroupScheduleListAddEdit.vue';
import { getResponseToMTH } from '@/utils/helpers';
import constants from '@/utils/constants';

class MenuGroupScheduleItem {
  id: string = '';
  outletCode: string = '';
  menuGroupCode: string = '';
  status: string = '';
  beginDate: number = 10000101;
  endDate: number = 99991231;
  beginDay: number = 0;
  endDay: number = 0;
  beginHour: number = 0;
  endHour: number = 0;
}

@Component({
  components: {
    editor: MenuGroupScheduleAddEdit
  }
})
export default class MenuGroupScheduleList extends RemoteDataTable<
  MenuGroupScheduleItem
  > {
  public pageTitle: string = 'Menu Group Schedule List';

  public newButtonText: string = 'New Menu Group Schedule';

  public fieldsSet: Array<RemoteDataField> = [
    new RemoteDataField({ key: 'index', label: '', sortable: false }),
    new RemoteDataField({ key: 'action', label: '', sortable: false }),

    new RemoteDataField({ key: 'outletCode', label: 'Outlet Code' }),
    new RemoteDataField({ key: 'menuGroupCode', label: 'Menu Group Code' }),
    new RemoteDataField({ key: 'status', label: 'Status' }),
    new RemoteDataField({ key: 'beginDate', label: 'Begin Date' }),
    new RemoteDataField({ key: 'endDate', label: 'End Date' }),
    new RemoteDataField({ key: 'beginDay', label: 'Begin Day' }),
    new RemoteDataField({ key: 'endDay', label: 'End Day' }),
    new RemoteDataField({ key: 'beginHour', label: 'Begin Hour' }),
    new RemoteDataField({ key: 'endHour', label: 'End Hour' })
  ];

  // to get page data
  get items(): MenuGroupScheduleItem[] {
    return this.$store.getters.GetAllMenuGroupSchedule;
  }

  get paging(): MenuGroupScheduleItem[] {
    return this.$store.getters.PagingMenuGroupSchedule;
  }

  get sorting(): MenuGroupScheduleItem[] {
    return this.$store.getters.SortingMenuGroupSchedule;
  }

  get filtering(): MenuGroupScheduleItem[] {
    return this.$store.getters.FilteringMenuGroupSchedule;
  }

  sortingChanged(ctx) {
    this.$store.dispatch('UpdateSortingMenuGroupSchedule', {
      byField: ctx.sortBy,
      isDesc: ctx.sortDesc
    });
  }

  filterChanged(isResetFilter) {
    this.$store.dispatch('UpdateFilteringMenuGroupSchedule', {
      isResetFilter: isResetFilter
    });
  }

  reload(id = null) {
    if (id === 1) {
      this.$store.state.menuGroupSchedule.pagingMenuGroupSchedule.page = 1;
    }
    this.$store.dispatch('GetAllMenuGroupSchedule');
  }

  // delete item
  deleteItem(item) {
    this.$swal({
      title: constants.ARE_YOU_SURE,
      text: constants.CONFIRM_DELETE_ITEM,
      icon: constants.STATUS_WARNING,
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        this.$store
          .dispatch('DeleteMenuGroupSchedule', item.id)
          .then(response => {
            getResponseToMTH(response, this.$swal, constants.RECORD_IS_DELETED);
          })
          .catch(error => {
            this.$swal(
              constants.SOMETHING_WROING,
              error.response.data.message,
              constants.STATUS_ERROR
            );
          });
      }
    });
  }
  mounted() {
    this.reload();
  }
  setPerPage(page) {
    this.$store.state.menuGroupSchedule.pagingMenuGroupSchedule.size = page;
    this.$store.dispatch('GetAllMenuGroupSchedule');
  }
}
